/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum Interventielaag {
    GOEDE_AANWEZIGHEID = "Goede aanwezigheid",
    BEGINNEND_VERZUIM = "Beginnend verzuim",
    AANHOUDEND_VERZUIM = "Aanhoudend verzuim"
}
